import { forwardRef } from 'react';

import { SegmentProps } from '@hh.ru/magritte-ui-segmented/types';

const SegmentForwardRefRenderFunc = () => null;

export const Segment = forwardRef<HTMLLabelElement, SegmentProps>(SegmentForwardRefRenderFunc);
